// extracted by mini-css-extract-plugin
export default {"overlay":"Ss-z","bodyOpen":"Ts-z","content":"Us-z","header":"Vs-z","close":"Ws-z","closeNoHeading":"Xs-z"};